import BuildIcon from '@mui/icons-material/BuildOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SmartToyIcon from '@mui/icons-material/SmartToyOutlined';
import ThreeSixtyOutlinedIcon from '@mui/icons-material/ThreeSixtyOutlined';
import { PathRoutes } from 'src/const/Routes/PathRoutes';

export const APKUrl =
  'https://play.google.com/store/apps/details?id=com.dunbarapp.Dunbar&hl=en&gl=US';
export const IOSUrl = 'https://apps.apple.com/us/app/dunbar-app/id6469200374';

export interface Route {
  title: string;
  path: string;
  icon?: JSX.Element;
  activeIcon?: JSX.Element;
  adminOnly?: boolean;
  children?: Route[];
}

export const ROUTES: Route[] = [
  {
    title: 'Feed',
    path: PathRoutes.FeedPageRoute,
    icon: <HomeOutlinedIcon />,
    activeIcon: <HomeOutlinedIcon sx={{ color: '#f0544f' }} />,
  },
  {
    title: 'Profile',
    path: PathRoutes.ProfileRoute,
    icon: <PersonOutlineIcon />,
    activeIcon: <PersonOutlineIcon sx={{ color: '#f0544f' }} />,
  },
  // TODO add URL and uncomment when applied to the marketing
  // website, which will open a URL in a new tab
  // {
  //   title: 'Info',
  //   path: CONSTANTS.ExternalUrl...,
  //   icon: <InfoOutlinedIcon />,
  //   activeIcon: <InfoOutlinedIcon sx={{ color: '#f0544f' }} />,
  // },
  {
    title: 'Admin Panel',
    path: PathRoutes.AdminPageRoute,
    icon: <BuildIcon />,
    activeIcon: <BuildIcon sx={{ color: '#f0544f' }} />,
    adminOnly: true,
    children: [
      {
        title: 'Coupons',
        path: PathRoutes.AdminPageRoute,
        icon: <LocalOfferOutlinedIcon />,
        activeIcon: <LocalOfferOutlinedIcon sx={{ color: '#f0544f' }} />,
        adminOnly: true,
      },
      {
        title: '360',
        path: PathRoutes.Admin360PageRoute,
        icon: <ThreeSixtyOutlinedIcon />,
        activeIcon: <ThreeSixtyOutlinedIcon sx={{ color: '#f0544f' }} />,
        adminOnly: true,
      },
    ],
  },
  ...(PathRoutes.AIAssistantRoute
    ? [
        {
          title: 'AI Assistant',
          path: PathRoutes.AIAssistantRoute,
          icon: <SmartToyIcon />,
          activeIcon: <SmartToyIcon sx={{ color: '#f0544f' }} />,
          adminOnly: true,
        },
      ]
    : []),
];

export const ROUTES_NO_AUTH = [];
